import { useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";

export default function Blogs() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  
  const dummyBlogs = [
    {
      id: 1,
      title: "Bridging the Gap Between Academia and Industry",
      excerpt: "Explore how collaborative platforms are revolutionizing the way researchers and companies work together.",
      category: "innovation",
      author: "Dr. Sarah Chen",
      date: "March 28, 2024",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
    {
      id: 2,
      title: "The Future of Research Collaboration",
      excerpt: "Discover the latest trends in cross-sector research partnerships and their impact on innovation.",
      category: "research",
      author: "Prof. Michael Rodriguez",
      date: "March 25, 2024",
      readTime: "8 min read",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
    {
      id: 3,
      title: "Career Growth in Tech: Tips for Early Researchers",
      excerpt: "Essential career advice for researchers looking to transition into industry roles.",
      category: "career",
      author: "Emma Thompson",
      date: "March 20, 2024",
      readTime: "6 min read",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
    {
      id: 4,
      title: "AI and Machine Learning: Current Breakthroughs",
      excerpt: "A comprehensive overview of the latest advancements in AI research and their real-world applications.",
      category: "technology",
      author: "Dr. James Wu",
      date: "March 18, 2024",
      readTime: "10 min read",
      image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
    {
      id: 5,
      title: "Building Diverse Research Teams",
      excerpt: "Why diversity matters in research and how to create inclusive collaborative environments.",
      category: "innovation",
      author: "Dr. Amelia Okonkwo",
      date: "March 15, 2024",
      readTime: "7 min read",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
    {
      id: 6,
      title: "Navigating Funding: Grants and Opportunities",
      excerpt: "A guide to finding and securing research funding for your projects.",
      category: "career",
      author: "Prof. Lisa Anderson",
      date: "March 12, 2024",
      readTime: "9 min read",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop",
      content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
    },
  ];

  const categories = [
    { id: "all", label: "All Posts", count: 6 },
    { id: "innovation", label: "Innovation", count: 2 },
    { id: "research", label: "Research", count: 1 },
    { id: "career", label: "Career", count: 2 },
    { id: "technology", label: "Technology", count: 1 },
  ];

  const filteredBlogs = selectedCategory === "all" 
    ? dummyBlogs 
    : dummyBlogs.filter(blog => blog.category === selectedCategory);

  return (
    <div className="w-full min-h-screen bg-gray-50">
      <Header hideFilter={true} />
      
      {/* Hero Section */}
      <div className="w-full bg-gradient-to-r from-[#0f6abf] to-[#0a5ca8] py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              AxionNest Blog
            </h1>
            <p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto">
              Insights, stories, and perspectives on research, innovation, and collaboration
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-4 space-y-4">
              {/* Categories */}
              <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Categories</h3>
                
                <div className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setSelectedCategory(category.id)}
                      className={`w-full flex items-center justify-between px-4 py-2.5 rounded-lg transition-all duration-200 text-left ${
                        selectedCategory === category.id
                          ? "bg-[#0f6abf] text-white"
                          : "bg-gray-50 text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      <span className="font-medium">{category.label}</span>
                      <span className={`text-sm ${selectedCategory === category.id ? "text-blue-100" : "text-gray-500"}`}>
                        {category.count}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Subscribe */}
              <div className="bg-gradient-to-r from-[#e8f0f7] to-[#dfefff] rounded-2xl border border-blue-100 p-6">
                <h4 className="font-semibold text-gray-900 mb-2">Subscribe</h4>
                <p className="text-sm text-gray-600 mb-4">
                  Get the latest blog posts delivered to your inbox
                </p>
                <input
                  type="email"
                  placeholder="Your email"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm mb-2 focus:outline-none focus:border-[#0f6abf]"
                />
                <button className="w-full bg-[#0f6abf] text-white rounded-lg py-2 font-medium hover:bg-[#0a5ca8] transition-colors text-sm">
                  Subscribe
                </button>
              </div>

              {/* Popular Tags */}
              <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                <h4 className="font-semibold text-gray-900 mb-3">Popular Tags</h4>
                <div className="flex flex-wrap gap-2">
                  {["Research", "Innovation", "Career", "Technology", "Collaboration", "AI"].map((tag) => (
                    <span
                      key={tag}
                      className="text-xs font-medium px-3 py-1.5 bg-blue-50 text-[#0f6abf] rounded-full border border-blue-100 hover:bg-blue-100 cursor-pointer transition-colors"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Blog Posts */}
          <div className="lg:col-span-3">
            <div className="space-y-6">
              {filteredBlogs.length > 0 ? (
                filteredBlogs.map((blog) => (
                  <article
                    key={blog.id}
                    className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-200 cursor-pointer"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
                      {/* Image */}
                      <div className="md:col-span-1 h-48 md:h-full">
                        <img
                          src={blog.image}
                          alt={blog.title}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      {/* Content */}
                      <div className="md:col-span-2 p-6 flex flex-col justify-between">
                        <div>
                          <div className="flex items-center gap-2 mb-3">
                            <span className="text-xs font-semibold px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-full">
                              {blog.category.charAt(0).toUpperCase() + blog.category.slice(1)}
                            </span>
                            <span className="text-xs text-gray-500">{blog.readTime}</span>
                          </div>

                          <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-[#0f6abf] transition-colors">
                            {blog.title}
                          </h3>

                          <p className="text-gray-600 text-sm leading-relaxed mb-4">
                            {blog.excerpt}
                          </p>
                        </div>

                        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 bg-[#0f6abf] rounded-full flex items-center justify-center text-white text-xs font-bold">
                              {blog.author.charAt(0)}
                            </div>
                            <div className="text-sm">
                              <p className="font-medium text-gray-900">{blog.author}</p>
                              <p className="text-xs text-gray-500">{blog.date}</p>
                            </div>
                          </div>
                          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </article>
                ))
              ) : (
                <div className="bg-white rounded-2xl border border-gray-200 p-12 text-center">
                  <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">No blogs found</h3>
                  <p className="text-gray-600">Check back soon for new posts in this category</p>
                </div>
              )}
            </div>

            {/* Pagination */}
            {filteredBlogs.length > 0 && (
              <div className="mt-12 flex items-center justify-center gap-2">
                <button className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
                  Previous
                </button>
                <button className="px-4 py-2 bg-[#0f6abf] text-white rounded-lg hover:bg-[#0a5ca8] transition-colors">
                  1
                </button>
                <button className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors">
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
